// extracted by mini-css-extract-plugin
export default {"PanelItem":"PanelItem_PanelItem__Rbxsl"};